import React from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import '../styles/Datenschutz.css';
import Accordion from '../components/Accordion';
import WebVisitorContent from './WebVisitorContent';
import CustomerVisitorContent from './CustomerVisitorContent';
import CandidateVisitorContent from './CandidateVisitorContent';
import SocialMediaContent from './SocialMediaContent';
import ScrollAnimation from '../components/ScrollAnimation';

const Datenschutz: React.FC = () => {
  const { t } = useTranslation();

  const accordionData = [
    {
      title: t('datenschutzWebVisitors'),
      content: <WebVisitorContent />,
    },
    {
      title: t('datenschutzCustomers'),
      content: <CustomerVisitorContent />,
    },
    {
      title: t('datenschutzCandidates'),
      content: <CandidateVisitorContent />,
    },
    {
      title: t('datenschutzSocialMedia'),
      content: <SocialMediaContent />,
    },
  ];

  return (
    <div className="datenschutz-page">
      <div className="datenschutz-container">
        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <h1 className="datenschutz-title">{t('datenschutzTitle')}</h1>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="datenschutz-section">
            <h2>{t('datenschutzIntroTitle')}</h2>
            <div className="datenschutz-content">
              <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('datenschutzIntroText')) }}></p>
            </div>
          </section>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <section className="datenschutz-section">
            <Accordion items={accordionData} allowMultipleOpen={false} />
          </section>
        </ScrollAnimation>
      </div>
    </div>
  );
};

export default Datenschutz;
